import AjaxUtils from "../utils/ajax-utils";

const PrivatePage = {
    ajax_url: script_var.ajax_url,
    $privatePageForm: document.querySelector('.js-check-password'),
    $inputPassword : document.querySelector('input[name=password]'),
    $inputPageId : document.querySelector('input[name=page_id]'),
    $inputNonce : document.querySelector('input[name=nonce]'),
    $inputAction : document.querySelector('input[name=action]'),
    $inputPasswordInfo : document.querySelector('.message'),
    $loadSpinner : document.querySelector('.loader'),
    init() {
        if(this.$privatePageForm) {
            this.checkPassword(this.$privatePageForm)
        }
        if(this.$inputPassword) {
            this.trackInputChange(this.$inputPassword)
        }
    },
    checkPassword ($form) {
        $form.addEventListener('submit', e => {
            e.preventDefault()
            if(this.$inputPassword.value.trim().length !==0) {
                this.$loadSpinner.classList.add('loading')
                AjaxUtils.postData(this.ajax_url, {
                    action: this.$inputAction.value,
                    nonce: this.$inputNonce.value,
                    password: this.$inputPassword.value,
                    page_id: this.$inputPageId.value
                }).then(response => {
                        if (response.success === true) {
                            location.reload()
                        } else {
                            if(this.$inputPasswordInfo.classList.contains('info')) {
                                this.$inputPasswordInfo.classList.remove('info')
                            }
                            this.$inputPassword.classList.add('error')
                            this.$inputPasswordInfo.classList.add('error')
                            this.$inputPasswordInfo.innerText = response.data
                        }
                    }
                ).finally(() => {
                    this.$loadSpinner.classList.remove('loading')
                })
            } else {
                this.$inputPasswordInfo.classList.add('info')
                this.$inputPasswordInfo.innerText = 'Veuillez renseigner le mot de passe'
            }
        })
    },
    trackInputChange($input)  {
        $input.addEventListener('input', e => {
            if(e.target.value.trim().length !==0) {
                if(this.$inputPasswordInfo.classList.contains('error')) {
                    this.$inputPasswordInfo.classList.remove('error')
                }
                if(this.$inputPassword.classList.contains('error')) {
                    this.$inputPassword.classList.remove('error')
                }
                this.$inputPasswordInfo.classList.remove('info')
            }
        })
    }
}

export default PrivatePage